<template>
  <Poptip v-model="contentVisible" popper-class="hover-card" :width="238" placement="right-start"  @mouseenter.native="mouseEnterHandler" @mouseleave.native="mouseLeaveHandler">
    <IndexCard :img="card.cover" :name="card.authorName" :office="card.lawOrCourseName" :times="card.viewCount" @click="goRecordDetail(card)">
      <template #operator>
        <VuiButton :class="['btn', {'disable': !card.enable && isLogin}]" type="warning" @mousemove="mouseLeaveHandler" @mouseleave="mouseEnterHandler" @click.stop="goRecordDetail(card)">
          <Icon type="md-lock" />
          观看课程
        </VuiButton>
      </template>
    </IndexCard>
    <div class="card" slot="content">
      <h3 class="card__title" v-html="card.title"></h3>
      <div v-if="card.courseTypeName" class="card__tag">{{  card.courseTypeName  }}</div>
      <div class="card__authors">
        <div v-for="author in card.authorInfo" :key="author.id" class="card__author">
          <img class="card__avatar" :src="author.authorAvatar" />
          <div class="card__author-detail">
            <div class="card__name">{{ author.authorName }}</div>
            <div class="card__office">{{ author.lawName }}</div>
          </div>
        </div>
      </div>
      <p class="card__desc">课程简介：<span v-html="card.description"></span></p>
      <div class="card__btn" @click="goRecordDetail(card)">查看详情 <Icon type="ios-arrow-forward" /></div>
    </div>
  </Poptip>
</template>

<script>
import IndexCard from './IndexCard.vue'
export default {
  name: 'PromoteCard',
  components: {
    IndexCard,
  },
  props: {
    card: Object,
    isLogin: Boolean,
  },
  data () {
    return {
      contentVisible: false,
    }
  },
  methods: {
    // 跳转到点播详情
    goRecordDetail (obj) {
      if (obj.enable) {
        let router = this.$router.resolve({ path: `/record/detail/${obj.id}` })
        window.open(router.href, '_blank')
      } else {
        if (this.isLogin) {
          this.$store.commit('app/setDrainagePopVisible', { flag: true, enableSign: obj.enableSign })
        } else {
          this.$Message.error('请先登录')
          this.$router.push({ name: 'Login' })
        }
      }
    },
    mouseEnterHandler () {
      if (this.timer2) {
        clearTimeout(this.timer2)
        this.timer2 = null
      }
      if (this.timer) return
      this.timer = setTimeout(() => {
        this.timer = null
        this.contentVisible = true
      }, 500)
    },
    mouseLeaveHandler () {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      if (this.timer2) return
      this.timer2 = setTimeout(() => {
        this.timer2 = null
        this.contentVisible = false
      }, 100)
    },
  },
}
</script>
